// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2famD","selected":"Chip_selected__2uPKh"};